import { FeatureEntitlements } from '../access-control/featureEntitlements'
import { useDomainAccessControl } from './domain/accessControl'

export const useIsScanAndPayRetailers = () => {
  const hasAccess = useDomainAccessControl()
  return hasAccess([
    {
      featureEntitlementIds: [FeatureEntitlements.ScanAndPayRetailers],
      restrictedBannersAllowed: true,
    },
  ])
}
